<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-3"><a id="Contents-A">Contents</a></p><a id="Contents-A">
</a></div><a id="Contents-A">
</a><div><a id="Contents-A">
<p class="ct"></p>
</a><p class="Contents-Entry"><a id="Contents-A"></a><a href="#/The_Spirit_and_the_Skull#toc_marker-1">The Spirit and the Skull</a></p>
<p class="Contents-Entry"><a href="#/The_Spirit_and_the_Skull1#toc_marker-2">Copyright</a></p>
<p class="Contents-Entry"><a href="#/#toc_marker-3">Contents</a></p>
<p class="Contents-Entry"><a href="#/The_Spirit_and_the_Skull3#toc_marker-4">Dedication</a></p>
<p class="Contents-Entry"><a href="#/The_Spirit_and_the_Skull4#toc_marker-5">Epigraph</a></p>
<p class="Contents-Entry"><a href="#/The_Spirit_and_the_Skull5#toc_marker-6">Unthinkable</a></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull6#toc_marker-7" title="Link target outside of Sample">Hunt</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull7#toc_marker-8" title="Link target outside of Sample">Discoveries</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull8#toc_marker-9" title="Link target outside of Sample">Trial</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull9#toc_marker-10" title="Link target outside of Sample">Interlude</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull10#toc_marker-11" title="Link target outside of Sample">Flesh</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull11#toc_marker-12" title="Link target outside of Sample">Ivory</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull12#toc_marker-13" title="Link target outside of Sample">Figurine</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull13#toc_marker-14" title="Link target outside of Sample">The Bear of the Cave Clan</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull14#toc_marker-15" title="Link target outside of Sample">Caught</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull15#toc_marker-16" title="Link target outside of Sample">Ice Eyes</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull16#toc_marker-17" title="Link target outside of Sample">Traps</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull17#toc_marker-18" title="Link target outside of Sample">Questions Without Answers</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull18#toc_marker-19" title="Link target outside of Sample">Journey to a Confession</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull19#toc_marker-20" title="Link target outside of Sample">Facts and Fictions</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull20#toc_marker-21" title="Link target outside of Sample">In the World of the Dead</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull21#toc_marker-22" title="Link target outside of Sample">Confrontation</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull22#toc_marker-23" title="Link target outside of Sample">The Mother’s Wisdom</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull23#toc_marker-24" title="Link target outside of Sample">Afterword &amp; Acknowledgements</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull24#toc_marker-25" title="Link target outside of Sample">More from this Author</span></p>
<p class="Contents-Entry"><span href="#/The_Spirit_and_the_Skull25#toc_marker-26" title="Link target outside of Sample">Contact Us</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Spirit_and_the_Skull2.vue?48495ad6